export function knock() {
  this.tweens.timeline({
    targets: this,
    alpha: 1,
    tweens: [
      {
        alpha: 1,
        onStart: () => {
          this.audio.knock.play();
        },
        duration: 205,
      },
      {
        alpha: 1,
        onStart: () => {
          this.audio.knock.play();
        },
        duration: 210,
      },
      {
        alpha: 1,
        onStart: () => {
          this.audio.knock.play();
        },
        duration: 200,
      }
    ]
  });
}